import { render, staticRenderFns } from "./PorletHookCustomRemote.vue?vue&type=template&id=30c510b2"
import script from "./PorletHookCustomRemote.vue?vue&type=script&lang=js"
export * from "./PorletHookCustomRemote.vue?vue&type=script&lang=js"
import style0 from "./PorletHookCustomRemote.vue?vue&type=style&index=0&id=30c510b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports